<template>
    <div class="additional-info-page">
        <div class="additional-info-form">
            <img src="../assets/img/grey-tick.svg" alt="" class="additional-info-icon">
            <h2 class="additional-info-header">Your account has been created successfully. <br/>Welcome to the best place for internet ot things - Simon IoT.</h2>
            <p class="additional-info-text">To use the portal, please fill in the additional information below.</p>
            <div class="form">
                <fieldset :class="[vErrors && vErrors.has('time-zone') ? 'error-field' : '']">
                    <label for="time-zone">Timezone</label>
                    <select class="form-control custom-select" name="time-zone" id="time-zone" v-model="additionalInfo.displayTimeZoneId" v-validate="'required'" data-vv-as="timezone">
                        <option v-for="zone in timeZones" v-bind:key="zone.id" :value="zone.id">{{zone.tzdbId.replace(/_/g, ' ')}}</option>
                    </select>
                    <span v-show="vErrors && vErrors.has('time-zone')" class="validate-warning">{{ vErrors.first('time-zone') }}</span>
                </fieldset>

                <fieldset>
                    <label for="referralCode">Referral Code (optional)</label>
                    <input type="text" class="form-control" id="referralCode" v-model="additionalInfo.referralCode"/>
                    <span v-if="errorMsg != ''" class="validate-warning">{{errorMsg}}</span>
                </fieldset>

                <fieldset :class="['terms-and-conditions', vErrors && vErrors.has('terms-conditions') ? 'error-field' : '']">
                    <div class="terms-and-conditions-box">
                        <input @click="showTermsModal" type="checkbox" name="terms-conditions" id="terms-conditions" v-model="termsConditionsAccepted" v-validate="'required'" data-vv-as="terms and conditions"/>
                        <label @click="showTermsModal" for="terms-conditions">
                            <span v-if="termsConditionsAccepted">I Accept the <span class="colored">Terms and Conditions</span></span>
                            <span v-else>Please read and accept the <span class="colored">Terms and conditions</span></span>
                        </label>
                    </div>
                    <span v-show="vErrors && vErrors.has('terms-conditions')" class="validate-warning">{{ vErrors.first('terms-conditions') }}</span>
                </fieldset>

                <fieldset :class="['recaptcha', (captchaError || captchaError2) ? 'error-field' : '']">
                    <vue-recaptcha ref="recaptcha" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod" sitekey="6LcqsQ8hAAAAACTgTWzvhWrGtGI61m3x3PLwq-9U" />
                    <span v-if="captchaError" class="validate-warning">Please fill the Captcha</span>
                    <span v-if="captchaError2" class="validate-warning">Captcha is missing or invalid</span>
                </fieldset>

                <div class="additional-info-btn-box">
                    <button class="btn btn-primary" :disabled="termsConditionsAccepted == false" @click="submitAdditionalInfo()">Complete</button>
                </div>
            </div>
            <b-modal hide-footer hide-header id="accept-terms" ref="accept-terms" size="lg" class="accept-terms" centered title="Terms and conditions">
                <div class="terms-and-conditions-topbar">
                    <h3>Terms and conditions</h3>
                    <i class="fa fa-close" @click="hideTermsModal()"></i>
                </div>
                <div class="terms-and-conditions-text" v-html="termsContent" @scroll="checkScroll"></div>
                <div :class="['accept-bar', termsRead ? 'buttons-visible' : 'text-visible']">
                    <button class="btn btn-light" @click="hideTermsModal()">Cancel</button>
                    <button class="btn btn-success accept" @click="acceptTerms()" :disabled="!termsRead">Accept Terms and Conditions</button>
                    <p>Scroll down to accept terms and conditions</p>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import Axios from "axios";
    import VueMeta from 'vue-meta'
    import globalStore from "../variables";
    import VueParticles from 'vue-particles'
    import vueCountryRegionSelect from "vue-country-region-select";
    import VeeValidate from 'vee-validate';
    import { VueRecaptcha } from 'vue-recaptcha'

    Vue.use(VueMeta, {
        refreshOnceOnNavigation: true
    })

    Vue.use(VueParticles)

    const veeValidateConfig = {
        errorBagName: 'vErrors'
    };

    Vue.use(VeeValidate, veeValidateConfig);

    export default {
        name: "AdditionalInfoForm",
        components: {
            VueRecaptcha
        },
        data() {
            return {
                additionalInfo: {
                    displayTimeZoneId: '',
                    referralCode: ''
                },
                termsConditionsAccepted: false,
                timeZones: '',
                termsRead: false,
                clientIp: '',
                termsContent: '',
                hintSelected: false,
                hintSelectedError: '',
                captchaToken: '',
                captchaError: false,
                captchaError2: false,
                displayHints: false,
                service: null,
                errorMsg: ''
            }
        },
        metaInfo () {
            return {
                script: [{
                    src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBvAuWDKz9dAP1Td4ZXSfdcrbeN9cX_glg&region=US&language=en-US&libraries=places',
                    async: true,
                    defer: true,
                    callback:() => this.mapsInit()
                }]
            }
        },
        methods: {
            errorMethod(response) {
                this.captchaError2 = true;
            },
            renderMethod(response) {
                this.captchaToken = '';
            },
            verifyMethod(response) {
                this.captchaToken = response;
                this.captchaError2 = false;
                this.captchaError = false;
            },
            expiredMethod(response) {
                this.captchaToken = '';
                this.captchaError2 = true;
            },
            getGeocoderRequest(placeId) {
                this.geoServices('GeocoderRequest', {
                    placeId: placeId
                }, this.geocoderResponse)
            },
            geocoderResponse(response, status) {
                console.log(response, status);
            },
            mapsInit() {
                this.service = new window.google.maps.places.AutocompleteService();
                this.geoServices = new window.google.maps.Geocoder();
            },
            displaySuggestions (predictions, status) {
                if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                    this.searchResults = [];
                    return
                }
                this.searchResults = predictions.map(prediction => prediction);
            },
            parseSelectedOption(data) {
                this.additionalInfo.addressLine1 = ''
                this.additionalInfo.addressLine2 = ''
                this.additionalInfo.city = ''
                this.additionalInfo.state = ''
                this.additionalInfo.postalCode = ''
                this.additionalInfo.country = ''
                let address = data.formatted_address
                let streetParsed = address.substr(0, address.indexOf(','))
                this.additionalInfo.addressLine1 = streetParsed
                let addressObject = data.address_components
                for (let part of addressObject) {
                    if (part.types[0] == "postal_town") {
                        this.additionalInfo.city = part.long_name
                    } else if (part.types[0] == "locality" && part.types[1] == "political") {
                        this.additionalInfo.city = part.long_name
                    } else if (part.types[0] == "administrative_area_level_1" && part.types[1] == "political") {
                        this.additionalInfo.state = part.short_name
                    } else if (part.types[0] == "country" && part.types[1] == "political") {
                        this.additionalInfo.country = part.long_name
                    } else if (part.types[0] == "postal_code") {
                        this.additionalInfo.postalCode = part.long_name
                    }
                }
            },
            getSelectedLocation(location) {
                this.geoServices.geocode({
                    placeId: location.place_id
                }, (result, status) => {
                    this.location = location.description
                    this.hintSelected = true
                    this.parseSelectedOption(result[0])
                })
            },
            showHints() {
                this.displayHints = true
            },
            hideHints() {
                setTimeout(() => {
                    this.displayHints = false
                },100)
            },
            unlockHints() {
                this.hintSelected = false
            },
            showTermsModal(ev) {
                ev.preventDefault();
                this.$refs['accept-terms'].show();
                this.termsConditionsAccepted = false;
                this.termsRead = false;
            },
            hideTermsModal() {
                this.termsConditionsAccepted = false;
                this.$refs['accept-terms'].hide();
            },
            acceptTerms() {
                this.termsConditionsAccepted = true;
                this.$refs['accept-terms'].hide();
            },
            checkScroll(ev) {
                let maxScroll = ev.target.scrollHeight - ev.target.clientHeight;
                let currentScrollPosition = ev.target.scrollTop;
                if (currentScrollPosition >= (maxScroll - 5)) {
                    this.termsRead = true;
                }
            },
            getTermsContent() {
                Axios.get(globalStore.data.restApiUrl + '/terms-and-conditions/most-recent')
                    .then(response => {
                        this.termsContent = response.data.content;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getTimezones() {
                Axios.get(`${globalStore.data.restApiUrl}/time-zones`)
                    .then(response => {
                        this.timeZones = response.data
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Get Timezones list',
                        text: 'Something was wrong with get timezones list.',
                        duration: 5000,
                    });
                    return false;
                })
            },
            submitAdditionalInfo() {
                this.errorMsg = ''
                if (this.captchaToken == '' || this.captchaError == true) {
                    this.captchaError = true;
                    return false;
                } else {
                    this.captchaError = false;
                }

                if (this.captchaError2 == true) {
                    return false;
                }

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let parsedData = {
                            displayTimeZoneId: this.additionalInfo.displayTimeZoneId
                        }
                        if (this.additionalInfo.referralCode) {
                            parsedData.referralCode = this.additionalInfo.referralCode
                        }
                            Axios.patch(globalStore.data.restApiUrl + '/account/additional-info', parsedData)
                                .then(() => {
                                    this.$notify({
                                        type: 'success',
                                        group: 'notification',
                                        title: 'Required Informations added',
                                        text: 'You can use all features of the portal now.',
                                        duration: 5000,
                                    });
                                    this.$router.push('/dashboard')
                                })
                                .catch(error => {
                                    window.grecaptcha.reset();
                                    this.captchaToken = '';
                                    if (error.response.data.errors[0].errorCode == 'VALIDATION_EXCEPTION') {
                                        this.errorMsg = 'Referral code incorrect'
                                    } else {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Required Informations adding error',
                                            text: 'Something went wrong during saving informations. Please, contact support.',
                                            duration: 5000,
                                        });
                                    }
                                    console.log(error)
                                })
                    }
                })
            }
        },
        mounted() {
            this.getTermsContent()
            this.getTimezones()
        },
        watch: {
            location (newValue) {
                if (newValue) {
                    this.service.getPlacePredictions({
                        input: this.location
                    }, this.displaySuggestions)
                }
            }
        }
    }
</script>
<style lang="scss">
    .additional-info-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        .additional-info-form {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            margin: 70px 0 0;
            background-color: #fff;
            border: 1px solid #C9CFD4;

            .additional-info-icon {
                margin: 30px 0 24px;
            }

            .additional-info-header {
                margin: 0 0 16px;
                color: #2F353A;
                font-size: 18px;
                line-height: 24px;
                text-align: center;
                font-weight: 400;
            }

            .additional-info-text {
                margin: 0 0 40px;
                color: #2F353A;
                font-size: 14px;
            }

            fieldset {
                position: relative;
                margin-bottom: 20px;

                .validate-warning {
                    position: absolute;
                    left: 0;
                    bottom: -16px;
                    color: #FC4D4D;
                    font-size: 12px;
                    transition: all .4s ease-in-out;
                }
            }

            .additional-info-btn-box {
                display: flex;
                justify-content: flex-end;
            }

            .auto-fill-address {
                position: relative;
                margin: 20px 0;

                .auto-fill-input {
                }

                .auto-fill-hints-list {
                    position: absolute;
                    top: 35px;
                    left: 0;
                    right: 0;
                    border: 1px solid #c9cfd4;
                    border-top: 0;
                    border-bottom-right-radius: 5px;
                    border-bottom-left-radius: 5px;
                    background-color: #fff;
                    z-index: 10;

                    .auto-fill-hint {
                        padding: 4px 10px;
                        border-bottom: 1px solid #c9cfd4;
                        cursor: pointer;

                        &:hover {
                            background-color: #f0f3f5;
                        }

                        &:last-child {
                            border-bottom: 0;
                        }
                    }
                }

                .auto-fill-error {
                    position: absolute;
                    top: 35px;
                    left: 0;
                    right: 0;
                    color: #FC4D4D;
                    font-size: 12px;
                }
            }

            .terms-and-conditions {
                margin-top: 20px;
                .terms-and-conditions-box {
                    display: flex;

                    label {
                        margin: 0 0 0 10px;
                        cursor: pointer;
                        span {
                            .colored {
                                color: #0088F1;
                            }
                        }
                    }
                    input {
                        cursor: pointer;
                    }
                }
            }
        }
    }

    #accept-terms___BV_modal_content_ {
        background-color: #ffffff;
        color: #000000;

        .terms-and-conditions-topbar {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            margin-bottom: 8px;

            h3 {
                font-size: 15px;
            }

            i {
                cursor: pointer;

                &:before {
                    color: #000000;
                }
            }
        }

        .terms-and-conditions-text {
            width: 100%;
            max-height: 80vh;
            overflow: scroll;
            padding-right: 12px;
        }

        .terms-and-conditions-text iframe {
            width: 100%;
            height: 70vh;
        }

        .accept-bar {
            display: flex;

            p {
                color: #0088FF;
            }

            &.buttons-visible {
                justify-content: flex-end;

                p {
                    display: none;
                }

                button {
                    display: initial;
                }

                .accept {
                    margin-left: 20px;
                }
            }

            &.text-visible {
                justify-content: center;

                button {
                    display: none;
                }

                p {
                    display: initial;
                }
            }
        }
    }
</style>